import HaspPage, { HaspTemplatePage } from '../Hasp/HaspPage';
import HaspObject from '../Hasp/HaspObject';
import HaspButton from '../Hasp/HaspButton';
import HaspLabel from '../Hasp/HaspLabel';
import HaspSwitch from '../Hasp/HaspSwitch';
import HaspCheckBox from '../Hasp/HaspCheckbox';
import HaspSlider from '../Hasp/HaspSlider';
import HaspBar from '../Hasp/HaspBar';
import HaspArc from '../Hasp/HaspArc';
import HaspGauge from '../Hasp/HaspGauge';
import HaspLineMeter from '../Hasp/HaspLineMeter';
import HaspTabview from '../Hasp/HaspTabview';
import HaspTab from '../Hasp/HaspTab';
import HaspLed from '../Hasp/HaspLed';
import HaspImage from '../Hasp/HaspImage';
import HaspButtonmatrix from '../Hasp/HaspButtonmatrix';
import HaspMsgbox from '../Hasp/HaspMsgbox';
import HaspDropdown from '../Hasp/HaspDropdown';
import HaspSpinner from '../Hasp/HaspSpinner';
import HaspRoller from '../Hasp/HaspRoller';
import HaspColorpicker from '../Hasp/HaspColorpicker';
import HaspQrcode from '../Hasp/HaspQrcode';
import HaspLine from '../Hasp/HaspLine';
import HaspChart from '../Hasp/HaspChart';
import HaspLegend from '../Hasp/HaspLegend';
import HaspBadge from '../Hasp/HaspBadge';
import HaspConnection from '../Hasp/HaspConnection';
import HaspH3d from '../Hasp/HaspH3d';


const lookupPageSize = {
    "small_landscape": { width: 320, height: 240, title: "Small 320x240" },
    "small_portrait": { width: 240, height: 320, title: "Small Portrait 240x320" },
    "large_landscape": { width: 480, height: 320, title: "Large Landcape 480x320" },
    "large_portrait": { width: 320, height: 480, title: "Large Portrait 320x480" },
    "large_square": { width: 480, height: 480, title: "Large Square 480x480" },
    "7inch_landscape": { width: 800, height: 480, title: "7\" Landcape 800x480" },
    "7inch_portrait": { width: 480, height: 800, title: "7\" Portrait 480x800" },
    "xlarge_landscape": { width: 800, height: 600, title: "X-large Landcape 800x600" },
    "xlarge_portrait": { width: 600, height: 800, title: "X-Large Portrait 600x800" },
}

const themeLookup = {
    "1": "Hasp Light",
    "2": "Hasp Dark",
    "3": "Mono",
    "4": "Material Light",
    "5": "Material Dark"
}

const objectTypelookup = {
    "page": HaspPage,
    "template_page": HaspTemplatePage,
    "obj": HaspObject,
    "btn": HaspButton,
    "label": HaspLabel,
    "switch": HaspSwitch,
    "checkbox": HaspCheckBox,
    'img': HaspImage,
    "bar": HaspBar,
    "slider": HaspSlider,
    "arc": HaspArc,
    "linemeter": HaspLineMeter,
    "tabview": HaspTabview,
    "tab": HaspTab,
    'gauge': HaspGauge,
    'btnmatrix': HaspButtonmatrix,
    'cpicker': HaspColorpicker,
    'dropdown': HaspDropdown,
    'led': HaspLed,
    'msgbox': HaspMsgbox,
    'qrcode': HaspQrcode,
    'roller': HaspRoller,
    'spinner': HaspSpinner,
    'line': HaspLine,
    'chart': HaspChart,
    'legend': HaspLegend,
    'badge': HaspBadge,
    'connection': HaspConnection,
    '3d': HaspH3d,
    'h3d': HaspH3d,
}

const lookupIcon = {
    "page": { icon: "media/icons/addPage.png", docicon: "media/hasp/haspPages.png", title: "Base Page object" },
    "obj": { icon: "media/icons/addObject.png", docicon: "media/hasp/haspObject.png", title: "Object to add other object to" },
    "btn": { icon: 'media/icons/addButton.png', docicon: "media/hasp/haspButton.png", title: "Button object" },
    "label": { icon: 'media/icons/addLabel.png', docicon: "media/hasp/haspLabel.png", title: "Label object" },
    "switch": { icon: 'media/icons/addSwitch.png', docicon: "media/hasp/haspSwitch.png", title: "Switch object" },
    "checkbox": { icon: 'media/icons/addCheckbox.png', docicon: "media/hasp/haspCheckbox.png", title: "Checkbox object" },
    'img': { icon: 'media/icons/addImage.png', docicon: "media/hasp/haspImage.png", title: "Image object" },
    "bar": { icon: 'media/icons/addBar.png', docicon: "media/hasp/haspBar.png", title: "Bar object" },
    "slider": { icon: 'media/icons/addSlider.png', docicon: "media/hasp/haspSlider.png", title: "Slider object" },
    "arc": { icon: 'media/icons/addArc.png', docicon: "media/hasp/haspArc.png", title: "Arc object" },
    "linemeter": { icon: 'media/icons/addLinemeter.png', docicon: "media/hasp/haspLinemeter.png", title: "Linemeter object" },
    "tabview": { icon: 'media/icons/addTabview.png', docicon: "media/hasp/haspTabview.png", title: "Tabview object" },
    "tab": { icon: 'media/icons/addTab.png', docicon: "media/hasp/haspTabview.png", title: "Tab object" },
    'gauge': { icon: 'media/icons/addGauge.png', docicon: "media/hasp/haspGauge.png", title: "Gauge object" },
    'btnmatrix': { icon: 'media/icons/addButtonmatrix.png', docicon: "media/hasp/haspButtonmatrix.png", title: "Button Matrix object" },
    'cpicker': { icon: 'media/icons/addCpicker.png', docicon: "media/hasp/haspCpicker.png", title: "Color picker object" },
    'dropdown': { icon: 'media/icons/addDropdown.png', docicon: "media/hasp/haspDropdown.png", title: "Dropdown menu" },
    'led': { icon: 'media/icons/addLed.png', docicon: "media/hasp/haspLed.png", title: "Led menu" },
    'msgbox': { icon: 'media/icons/addMessagebox.png', docicon: "media/hasp/haspMessagebox.png", title: "Messagebox" },
    'qrcode': { icon: 'media/icons/addQrcode.png', docicon: "media/hasp/haspQrcode.png", title: "QrCode" },
    'roller': { icon: 'media/icons/addRoller.png', docicon: "media/hasp/haspRoller.png", title: "Roller" },
    'spinner': { icon: 'media/icons/addSpinner.png', docicon: "media/hasp/haspSpinner.png", title: "Spinner" },
    'line':    { icon: 'media/icons/addLine.png',   docicon: "media/hasp/haspLine.png",   title: "Line" },
    'chart':   { icon: 'media/icons/addChart.png', title: "Chart object" },
    'legend':  { icon: 'media/icons/addLegend.png', title: "Legend object" },
    'badge':   { icon: 'media/icons/addBadge.png', title: "Badge object" },
    '3d':      { icon: 'media/icons/addObject.png', title: "3D model object" },

    'delete': { icon: 'media/icons/trash.png', title: "Delete" },
    'import': { icon: 'media/icons/import.png', title: "Import" },
    'export': { icon: 'media/icons/export.png', title: "Export" },
    'settings': { icon: 'media/icons/settings.png', title: "Settings" },

}

const servicesLookup = {
    'automation': ['', 'turn_on', 'turn_off', 'toggle', 'trigger', 'reload'],
    'climate': ['', 'turn_on', 'turn_off', 'toggle', 'set_temperature'],
    'cover': ['', 'open_cover', 'close_cover', 'stop_cover', 'set_cover_position'],
    'fan': ['', 'turn_on', 'turn_off', 'toggle', 'set_percentage'],
    'homeassistant': ['', 'turn_on', 'turn_off', 'toggle'],
    'input_boolean': ['', 'turn_on', 'turn_off', 'toggle'],
    'input_select': ['', 'select_option', 'select_next', 'select_previous'],
    'light': ['', 'turn_on', 'turn_off', 'toggle'],
    'media_player': ['', 'turn_on', 'turn_off', 'toggle', 'media_play', 'media_pause', 'media_stop', 'volume_set', 'volume_up', 'volume_down'],
    'scene': ['', 'turn_on'],
    'script': ['', 'turn_on'],
    'switch': ['', 'turn_on', 'turn_off', 'toggle'],
    'esphome': [],
}

const shortcutLookup = {
    "p": "page",
    "o": "obj",
    "b": "btn",
    "l": "label",
    "s": "switch",
    "c": "checkbox",
    "i": 'img',
    "ctrl-b": "bar",
    "ctrl-s": "slider",
    "a": "arc",
    "ctrl-l": "linemeter",
    "t": "tabview",
    "ctrl-t": "tab",
    "g": 'gauge',
    "alt-b": 'btnmatrix',
    "ctrl-c": 'cpicker',
    "d": 'dropdown',
    "alt-l": 'led',
    "m": 'msgbox',
    "r": 'roller',
    "alt-s": 'spinner',
    "w": 'line',
    "ctrl-h": 'chart',
    "ctrl-i": 'import',
    "ctrl-e": 'export',
}

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}


export { objectTypelookup, themeLookup, lookupPageSize, lookupIcon, shortcutLookup, servicesLookup, getKeyByValue }
export { HaspTemplatePage }
